import { FormProvider, useForm } from 'react-hook-form';
import { useCallback } from 'react';
import ControlledInput from '../../components/ControlledInput';
import BtnFilled from '../../components/BtnFilled';
import * as React from 'react';
import { COMMON_FORM_ERRORS } from '../../constants';
import { useThrottle } from '../../hooks';
import { sendEngineerInvitation } from '../../api/api';
import { toast } from 'react-toastify';
import { useInvitationsStore } from './state/use-invitations-store';
import { useRolesStore } from './state/use-roles-store';
import ControlledDropdown from '../../components/ControlledDropdown';

const generalProps = {
  rules: {
    required: {
      value: true,
      message: COMMON_FORM_ERRORS.REQUIRED,
    },
  },
};

const InvitationForm = ({ closeModal }) => {
  const methods = useForm({ mode: 'onTouched' });
  const { fetchInvitations } = useInvitationsStore();
  const { roles } = useRolesStore();

  const successHandle = async () => {
    methods.reset();
    toast.success('Пригласительная ссылка успешно отправлена');
    await fetchInvitations();
    closeModal();
  };

  const throttleSubmit = useThrottle(async (data) => {
    const formData = { ...data, redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'engineerRegistration' };
    await sendEngineerInvitation(formData, successHandle, (value) => toast.error(`Произошла ошибка: ${value?.error ?? ''}`));
  }, 500);

  const handleSubmit = useCallback(
    (data) => {
      throttleSubmit(data);
    },
    [throttleSubmit]
  );

  const fields = [
    { name: 'email', field: 'input', type: 'email', label: 'Введите email', placeholder: 'someone@example.com' },
    {
      name: 'role',
      field: 'select',
      type: 'text',
      label: 'Роль пользователя',
      options: roles,
      valkey: 'key',
      optkey: 'name',
      placeholder: 'Выберите роль',
      className: 'mb-4',
    },
  ];

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        {fields.map((input) => {
          if (input?.field === 'input') {
            return <ControlledInput {...generalProps} key={input.name} {...input} />;
          }

          if (input?.field === 'select') {
            return <ControlledDropdown {...generalProps} {...input} />;
          }
        })}
        <BtnFilled className={'w-max flex mx-auto'} disabled={!methods.formState.isValid} type={'submit'} title={'Отправить пригласительную ссылку'} />
      </form>
    </FormProvider>
  );
};

export default InvitationForm;
